import { styled } from "@tamagui/core";
import { Icon as IconComponent } from "./Icon.InternalIcon";
const StyledIcon = styled(IconComponent, {
    defaultVariants: {
      size: "regular"
    },
    name: "baseIcon",
    variants: {
      size: {
        // allows to forward any number as a size. It's kind of like a "catchAll"
        ":number": val => ({
          height: val,
          width: val
        }),
        huge: {
          height: "$icon.huge",
          width: "$icon.huge"
        },
        large: {
          height: "$icon.large",
          width: "$icon.large"
        },
        massive: {
          height: "$icon.massive",
          width: "$icon.massive"
        },
        regular: {
          height: "$icon.regular",
          width: "$icon.regular"
        },
        small: {
          height: "$icon.small",
          width: "$icon.small"
        }
      }
    }
  }, {
    accept: {
      color: "color"
    },
    acceptsClassName: !0
  }),
  Icon = StyledIcon;
Icon.displayName = "Icon";
export { Icon, StyledIcon };
//# sourceMappingURL=Icon.mjs.map
